import { TokenState } from '@incentivegames/ig-frontend-common/lib/contexts/userContext';
import useIGTranslation from 'hooks/useIGTranslation';
import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import './LoginRevealButton.scss';
import { loginRevealButtonFunctions } from './loginRevealButtonFunctions';

export interface LoginRevealButton {
  pathName?: string;
  searchLocation: string;
  token?: string;
  tokenState: TokenState;
  handleStartPlayingClick: () => void;
  roundStartTime?: number;
}

const LoginRevealButton = ({ pathName, searchLocation, token, tokenState, handleStartPlayingClick, roundStartTime }: LoginRevealButton) => {
  const [started, setStarted] = useState<boolean>(false);
  const { t } = useIGTranslation();
  const checkedTokenState = loginRevealButtonFunctions.checkTokenState(tokenState, roundStartTime);

  return (
    <NavLink
      className="login-reveal-button"
      to={{ pathname: pathName, search: searchLocation }}
      onClick={(event) => {
        event.preventDefault();
        if (started) {
          return;
        }
        if (token) {
          setStarted(true);
        }
        console.log(roundStartTime);
        handleStartPlayingClick();
      }}
    >
      {t(checkedTokenState)}
    </NavLink>
  );
};

export default LoginRevealButton;
